import AjaxStore from '../../Core/data/AjaxStore.js';
import ResourceTickModel from '../model/ResourceTickModel.js';
import DateStoreLazyLoadPlugin from './plugin/DateStoreLazyLoadPlugin.js';
import PagedDateStoreLazyLoadPlugin from './plugin/PagedDateStoreLazyLoadPlugin.js';

/**
 * @module Scheduler/data/ResourceTickStore
 */

/**
 * A class representing a collection of resource ticks.
 * Contains a collection of {@link Scheduler.model.ResourceTickModel} records.
 * The class is used by the {@link Scheduler.feature.TickCells} feature.
 *
 * ```javascript
 * const store = new ResourceTickStore({
 *     data : [{        {
 *         id             : 1,
 *         startDate      : '2019-01-01T11:00',
 *         value          : 2,
           resourceId     : 1,
           durationUnit   : 'day',
           duration       : 1
 *     }]
 * });
 * ```
 *
 * @extends Core/data/AjaxStore
 *
 * @plugins Scheduler/data/plugin/DateStoreLazyLoadPlugin
 * @internal
 */
export default class ResourceTickStore extends AjaxStore {
    static $name = 'ResourceTickStore';

    static configurable = {
        /**
         * CrudManager must load stores in the correct order. Lowest first.
         * @private
         */
        loadPriority : 500,

        /**
         * CrudManager must sync stores in the correct order. Lowest first.
         * @private
         */
        syncPriority : 500,

        modelClass : ResourceTickModel,
        id         : 'resourceTicks' // no-sanity
    };

    get $lazyLoadPluginClass() {
        return this.isPaged ? PagedDateStoreLazyLoadPlugin : DateStoreLazyLoadPlugin;
    }
}
